const accordions = document.querySelectorAll('[data-accordion]');
const accordionAutoClose = document.querySelectorAll('.accordion--auto-close');

export default () => {
  accordions.forEach((accordion) => {
    // elements
    const els = {
      header: accordion.querySelector('[data-accordion-header]'),
      content: accordion.querySelector('[data-accordion-content]'),
      chevron: accordion.querySelector('[data-accordion-chevron]'),
      chevronText: accordion.querySelector('[data-accordion-chevron-text]'),
    };

    // classes
    const classes = {
      contentClosed: 'accordion__content--closed',
      chevronOpen: 'accordion__chevron--open',
    };

    // functions
    const openAccordion = () => {
      accordion.setAttribute('aria-expanded', true);
      accordion.dataset.accordion = 'open';

      els.chevron.classList.remove(classes.chevronOpen);
      els.content.classList.remove(classes.contentClosed);

      els.content.style.display = 'block';
      els.content.style.transition = 'height .3s';

      const contentHeight = els.content.scrollHeight;
      els.content.style.height = `${contentHeight}px`;

      els.chevronText.innerText = 'Close';
    };

    const closeAccordion = () => {
      accordion.dataset.accordion = 'closed';
      accordion.setAttribute('aria-expanded', false);

      const contentHeight = els.content.scrollHeight;
      els.chevron.classList.add(classes.chevronOpen);
      els.content.classList.add(classes.contentClosed);

      els.content.style.height = `${contentHeight}px`;
      els.content.style.transition = 'height .3s';

      window.requestAnimationFrame(() => {
        // “pausing” the JavaScript execution to let the rendering threads catch up
        // http://stackoverflow.com/questions/779379/why-is-settimeoutfn-0-sometimes-useful
        setTimeout(() => {
          els.content.style.height = 0;
          els.chevronText.innerText = 'Open';
        }, 0);
      });
    };

    const hideSiblings = () => {
      if (accordionAutoClose) {
        for (let i = 0; i < accordionAutoClose.length; i += 1) {
          if (accordionAutoClose[i] !== accordion) {
            const content = accordionAutoClose[i].querySelector('[data-accordion-content]');
            const chevron = accordionAutoClose[i].querySelector('[data-accordion-chevron]');
            const chevronText = accordionAutoClose[i].querySelector('[data-accordion-chevron-text]');
            accordionAutoClose[i].dataset.accordion = 'closed';
            accordionAutoClose[i].setAttribute('aria-expanded', false);
            const contentHeight = content.scrollHeight;
            chevron.classList.add(classes.chevronOpen);
            content.classList.add(classes.contentClosed);
            content.style.height = `${contentHeight}px`;
            content.style.transition = 'height .3s';
            window.requestAnimationFrame(() => {
              // “pausing” the JavaScript execution to let the rendering threads catch up
              // http://stackoverflow.com/questions/779379/why-is-settimeoutfn-0-sometimes-useful
              setTimeout(() => {
                content.style.height = 0;
                chevronText.innerText = 'Open';
              }, 0);
            });
          }
        }
      }
    };

    const toggleAccordion = () => {
      const state = accordion.dataset.accordion;
      hideSiblings();
      if (state === 'closed') {
        openAccordion();
      } else {
        closeAccordion();
      }
    };

    const init = () => {
      const state = accordion.dataset.accordion;
      if (state === 'closed') {
        closeAccordion();
      }
    };

    // handlers
    const handleTransitionEnd = () => {
      const state = accordion.dataset.accordion;
      if (state === 'open') {
        els.content.style.height = 'auto';
      } else if (state === 'closed') {
        els.content.style.display = 'none';
      }
    };

    // apply handlers
    els.content.addEventListener('transitionend', handleTransitionEnd);

    // stop the above line of code from running in the case of a tag animating on focus or hover
    els.content.querySelectorAll('a').forEach((el) => el.addEventListener('transitionend', (e) => e.stopPropagation()));

    els.header.addEventListener('click', () => toggleAccordion(accordion));

    els.header.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === 'Spacebar' || e.key === ' ') {
        e.preventDefault();
        toggleAccordion(accordion);
      }
    });

    accordion.open = openAccordion;
    accordion.close = closeAccordion;
    accordion.hideSiblings = hideSiblings;
    accordion.handleTransitionEnd = handleTransitionEnd;

    // init
    init();
  });
};
